export default function PHP_ReferenceSimpleXML() {
  return (
    <div>
      <h1>PHP_ReferenceSimpleXML</h1>
    </div>
  );
}
